<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M11.7778 2C6.26018 2 1.77783 6.48235 1.77783 12C1.77783 17.5176 6.26018 22 11.7778 22C17.2955 22 21.7778 17.5176 21.7778 12C21.7778 6.48235 17.2955 2 11.7778 2ZM11.7778 20.8235C6.90724 20.8235 2.9543 16.8706 2.9543 12C2.9543 7.12941 6.90724 3.17647 11.7778 3.17647C16.6484 3.17647 20.6014 7.12941 20.6014 12C20.6014 16.8706 16.6484 20.8235 11.7778 20.8235ZM18.0484 12.5882V13.7647H10.9896V7.88235H12.1661V12.5882H18.0484Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
